import React, { useState } from "react";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import DialogTransition from "@icarius-common/dialogTransition";
import { GalleryDialog } from "@icarius-common/galleryDialog";
import PaperDraggable from "@icarius-common/paperDraggable";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { CloseIcon } from "@icarius-icons";
import { getLocalizedString } from "@icarius-localization/strings";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { createTypesOfBenefitsAction, modifyTypesOfBenefitsAction } from "../../../actions";
import CustomNumberFormat from '@icarius-common/dynamicInputs/customNumberFormat';
import useHandleForm from "./useHandleForm";
import GalleryButtonAndDisplay from "@icarius-common/galleryDialog/components/galleryButtonAndDisplay";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const gridStyle = { height: 75, padding: "0px 10px" };
const gridStyleNoHeight = { padding: "0px 10px", marginTop: "15px" };
const flexStyle = { height: 50, padding: "0px 10px", display: "flex", alignItems: "center", cursor: "pointer" };

const CreateEditDialog = (props) => {

  const {
    open,
    isAdmin,
    isView,
    modeList,
    conceptList,
    frequencyList,
    daysAuthorizedList,
    loading,
    data,
    handleClose,
  } = props;

  const dispatch = useDispatch();
  const [imagesDialogIsOpen, setImagesDialogIsOpen] = useState(false);

  const create = (dataToSend) => {
    if (dataToSend.mode !== "SM" && dataToSend.daysAuthorized) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("ifYouEnterAuthorizedAbsenceDaysYouMustDefineAccessModeViaRequestToManager"),
        severity: "error",
        duration: null,
      }));
      return;
    }


    if (Boolean(dataToSend.concept) && dataToSend.mode !== "SE") {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("ifYouEnterRelatedPaymentConceptYouMustDefineAsAccessMethodViaEmployerRequest"),
        severity: "error",
        duration: null,
      }));
      return;
    }

    if (dataToSend.mode === "CP" && (!dataToSend.points || !parseInt(dataToSend.points))) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("pointsExchangeModeRequiresRequiredPoints"),
        severity: "error",
        duration: null,
      }));
      return;
    }

    if (dataToSend.mode === "LD" && (dataToSend.points || dataToSend.daysAuthorized || dataToSend.concept)) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("toDefineAccessModeWithFreeDispositionCannotHavePointsOrAuthorizedAbsenceDaysOrRelatedPaymentConcept"),
        severity: "error",
        duration: null,
      }));
      return;
    }

    if (dataToSend.mode === "SM" && !dataToSend.daysAuthorized) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("toDefineAccessModeViaRequestToManagerYouMustHaveAuthorizedAbsenceDays"),
        severity: "error",
        duration: null,
      }));
      return;
    }

    if (Boolean(dataToSend.concept) && (!dataToSend.value || dataToSend.value === "0.00" || dataToSend.value === 0.00)) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("toDefinePaymentConceptLinkedToBenefitValueOfBenefitMustBeGreaterThanZero"),
        severity: "error",
        duration: null,
      }));
      return;
    }

    dispatch(createTypesOfBenefitsAction(dataToSend))
      .then((res) => res?.status === 200 && handleClose());
  }

  const modify = (dataToSend) => {

    if (dataToSend.mode !== "SM" && dataToSend.daysAuthorized) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("ifYouEnterAuthorizedAbsenceDaysYouMustDefineAccessModeViaRequestToManager"),
        severity: "error",
        duration: null,
      }));
      return;
    }


    if (Boolean(dataToSend.concept) && dataToSend.mode !== "SE") {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("ifYouEnterRelatedPaymentConceptYouMustDefineAsAccessMethodViaEmployerRequest"),
        severity: "error",
        duration: null,
      }));
      return;
    }

    if (dataToSend.mode === "CP" && (!dataToSend.points || !parseInt(dataToSend.points))) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("pointsExchangeModeRequiresRequiredPoints"),
        severity: "error",
        duration: null,
      }));
      return;
    }

    if (dataToSend.mode === "LD" && (dataToSend.points || dataToSend.daysAuthorized || dataToSend.concept)) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("toDefineAccessModeWithFreeDispositionCannotHavePointsOrAuthorizedAbsenceDaysOrRelatedPaymentConcept"),
        severity: "error",
        duration: null,
      }));
      return;
    }


    if (dataToSend.mode === "SM" && !dataToSend.daysAuthorized) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("toDefineAccessModeViaRequestToManagerYouMustHaveAuthorizedAbsenceDays"),
        severity: "error",
        duration: null,
      }));
      return;
    }



    if (Boolean(dataToSend.concept) && (!dataToSend.value || dataToSend.value === "0.00" || dataToSend.value === 0.00)) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("toDefinePaymentConceptLinkedToBenefitValueOfBenefitMustBeGreaterThanZero"),
        severity: "error",
        duration: null,
      }));
      return;
    }
    dispatch(modifyTypesOfBenefitsAction(dataToSend))
      .then((res) => res?.status === 200 && handleClose());
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    isCreate,
    formData,
    setFormValue,
    submit,
  } = useHandleForm(data, create, modify, openValidationError);

  if (loading) return null;

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={DialogTransition}
        PaperComponent={PaperDraggable}
        maxWidth={"md"}
        fullWidth={true}
      >
        <div className={"dialog-container"}>
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            {isView ? getLocalizedString("viewBenefitType") : isCreate ? getLocalizedString("createBenefitType") : getLocalizedString("editBenefitType")}
            <DialogTitleDivider />
          </DialogTitle>
          <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
          <DialogContent>
            <Grid container item xs={12}>
              <Grid container item alignItems="center" xs={12} md={6} style={gridStyle}> {/* code */}
                <TextField
                  disabled={isView || !isCreate}
                  fullWidth
                  required
                  margin={"none"}
                  label={getLocalizedString("benefitCode")}
                  value={formData.code}
                  onChange={(e) => setFormValue(e.target.value, "code")}
                  inputProps={{ maxLength: 20 }}
                />
              </Grid>
              <Grid container item alignItems="center" xs={12} md={6} style={gridStyle}> {/* name */}
                <TextField
                  disabled={isView}
                  fullWidth
                  required
                  margin={"none"}
                  label={getLocalizedString("benefitName")}
                  value={formData.name}
                  onChange={(e) => setFormValue(e.target.value, "name")}
                  inputProps={{ maxLength: 100 }}
                />
              </Grid>
              <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* mode */}
                <FormControl style={{ width: "100%" }}>
                  <InputLabel required id={`label-mode`}>{getLocalizedString("accessMode")}</InputLabel>
                  <Select
                    disabled={isView}
                    value={formData.mode}
                    labelId={`label-mode`}
                    id={`select-mode`}
                    onChange={(e) => setFormValue(e.target.value, "mode")}
                    margin={"none"}
                  >
                    {
                      modeList.map(item => (
                        <MenuItem
                          className={"whiteText"}
                          key={item.key}
                          value={item.key}>
                          {item.value}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
              <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* daysAuthorized */}
                <FormControl style={{ width: "100%" }}>
                  <InputLabel required id={`label-daysAuthorized`}>{getLocalizedString("authAbsenceDays")}</InputLabel>
                  <Select
                    disabled={isView}
                    value={formData.daysAuthorized}
                    labelId={`label-daysAuthorized`}
                    id={`select-daysAuthorized`}
                    onChange={(e) => setFormValue(e.target.value, "daysAuthorized")}
                    margin={"none"}
                  >
                    {
                      daysAuthorizedList.map(item => (
                        <MenuItem
                          className={"whiteText"}
                          key={item.key}
                          value={item.key}>
                          {item.value}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
              <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
                <div style={flexStyle} onClick={isView ? null : () => setFormValue(!Boolean(formData.active), "active")}>
                  <Typography className="whiteText" variant="subtitle1" style={{ display: "inline-block" }}>
                    {getLocalizedString("active")}
                  </Typography>
                  <Checkbox checked={Boolean(formData.active)} />
                </div>
              </div>
              <Grid container item alignItems="center" xs={12} style={gridStyleNoHeight}> {/* description */}
                <TextFieldMultiline
                  disabled={isView}
                  required
                  fullWidth
                  margin={"none"}
                  label={getLocalizedString("benefitDescription")}
                  value={formData.description}
                  onChange={(e) => setFormValue(e.target.value, "description")}
                  rows={5}
                />
              </Grid>
              <Grid container item alignItems="center" xs={12} style={gridStyleNoHeight}> {/* requisites */}
                <TextFieldMultiline
                  disabled={isView}
                  fullWidth
                  margin={"none"}
                  label={getLocalizedString("requirementsAndConditions")}
                  value={formData.requisites}
                  onChange={(e) => setFormValue(e.target.value, "requisites")}
                  rows={5}
                />
              </Grid>
              <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* frequency */}
                <FormControl style={{ width: "100%" }}>
                  <InputLabel required id={`label-frequency`}>{getLocalizedString("usageFrequency")}</InputLabel>
                  <Select
                    disabled={isView}
                    value={formData.frequency}
                    labelId={`label-frequency`}
                    id={`select-frequency`}
                    onChange={(e) => setFormValue(e.target.value, "frequency")}
                    margin={"none"}
                  >
                    {
                      frequencyList.map(item => (
                        <MenuItem
                          className={"whiteText"}
                          key={item.key}
                          value={item.key}>
                          {item.value}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
              <Grid container item alignItems="center" xs={12} md={6} style={gridStyle}> {/* points */}
                <TextField
                  disabled={isView}
                  fullWidth
                  margin={"none"}
                  label={getLocalizedString("requiredPoints")}
                  value={formData.points}
                  onChange={(e) => setFormValue(e.target.value, "points")}
                  InputProps={{ inputComponent: CustomNumberFormat }}
                  inputProps={{ min: "1", step: "0.1", decimals: 0 }}
                />
              </Grid>
              <Grid container direction="row" justify="center" alignItems="flex-start">
                <Grid container item alignItems="center" xs={12} sm={6} style={Boolean(formData.concept) && Number(formData.value) <= 0 ? { ...gridStyle, height: "auto" } : gridStyle}> {/* concept */}
                  <FormControl style={{ width: "100%" }}>
                    <InputLabel id={`label-concept`}>{getLocalizedString("relatedPaymentConcept")}</InputLabel>
                    <Select
                      disabled={isView}
                      value={formData.concept}
                      labelId={`label-concept`}
                      id={`select-concept`}
                      onChange={(e) => setFormValue(e.target.value, "concept")}
                      margin={"none"}
                    >
                      <MenuItem className={"whiteText"} value={""}>
                        {""}
                      </MenuItem>
                      {
                        conceptList.map(item => (
                          <MenuItem
                            className={"whiteText"}
                            key={item.key}
                            value={item.key}>
                            {item.value}
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </Grid>
                <Grid container item alignItems="center" xs={12} md={6} style={gridStyle} > {/* value */}
                  <TextField
                    fullWidth
                    required={Boolean(formData.concept)}
                    disabled={isView}
                    margin={"none"}
                    label={getLocalizedString("benefitValue")}
                    value={formData.value}
                    onChange={(e) => setFormValue(e.target.value, "value")}
                    InputProps={{ inputComponent: CustomNumberFormat }}
                    inputProps={{ min: "1", step: "0.1", decimals: 2 }}
                    helperText={Boolean(formData.concept) && Number(formData.value) <= 0 && getLocalizedString("toDefinePaymentConceptLinkedToBenefitValueOfBenefitMustBeGreaterThanZero")}
                  />
                </Grid>
              </Grid>
              <Grid container item alignItems="center" xs={12} md={6} style={gridStyle} > {/* maxBenefitBudget */}
                <TextField
                  fullWidth
                  disabled={isView || (!isView && Number(formData.value) <= 0)}
                  margin={"none"}
                  label={getLocalizedString("benefitMaximumBudget")}
                  value={formData.maxBenefitBudget}
                  onChange={(e) => setFormValue(e.target.value, "maxBenefitBudget")}
                  InputProps={{ inputComponent: CustomNumberFormat }}
                  inputProps={{ min: "1", step: "0.1", decimals: 2 }}
                />
              </Grid>
              <Grid container item alignItems="center" xs={12} md={6} style={gridStyle} > {/* link */}
                <TextField
                  fullWidth
                  margin={"none"}
                  label={getLocalizedString("publicationLink")}
                  value={formData.link}
                  onChange={(e) => setFormValue(e.target.value, "link")}
                  inputProps={{ maxLength: 254 }}
                />
              </Grid>
              {
                isAdmin &&
                <Grid container item alignItems="center" xs={12} style={gridStyleNoHeight}> {/* sql */}
                  <TextFieldMultiline
                    disabled={isView}
                    fullWidth
                    margin={"none"}
                    label={getLocalizedString("conditionalSQL")}
                    value={formData.sql}
                    onChange={(e) => setFormValue(e.target.value, "sql")}
                    helperText={getLocalizedString("forConditionalSqlFiltersRememberYouHaveVariablesCodempAndEmployeeWhichContainEmployeeCodeAndWillDisplayAvailableBenefits")}
                    rows={5}
                  />
                </Grid>
              }
              <Grid container item alignItems="center" xs={12} style={gridStyleNoHeight}>
                <GalleryButtonAndDisplay
                  disabled={isView}
                  image={formData.image}
                  handleOpenGallery={() => setImagesDialogIsOpen(true)}
                />
              </Grid>
            </Grid>
          </DialogContent>
          {
            !isView &&
            <DialogActions>
              <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
              <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
            </DialogActions>
          }
        </div>
      </Dialog>
      {
        imagesDialogIsOpen &&
        <GalleryDialog
          open={imagesDialogIsOpen}
          initialValue={formData.image}
          type={"news"}
          handleSubmit={(image) => setFormValue(image, "image")}
          handleClose={() => setImagesDialogIsOpen(false)}
        />
      }
    </>
  );
}

export default CreateEditDialog;